import { render, staticRenderFns } from "./401-forbidden.vue?vue&type=template&id=cddc7346"
import script from "./401-forbidden.vue?vue&type=script&lang=js"
export * from "./401-forbidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports